import PolicyPage from "@/components/site/PolicyPage";

export default function CancellationPolicy() {
  return <PolicyPage slug="cancellation" fallbackTitle="Cancellation policy" testId="page-cancellation-policy" />;
}
